export default __webpack_public_path__ + "static/media/teachers.8366f331.jpg";